import React, { useState, useMemo } from 'react';
import LightboxBase from 'yet-another-react-lightbox';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import 'yet-another-react-lightbox/styles.css';

export default function Lightbox({
  images,
  isOpen,
  onClose,
  getImageSrc = (image) => image.path,
  getImageTitle = (index) => `${index + 1}/${images.length}`,
}) {
  const [index, setIndex] = useState(0);

  const nextIndex = useMemo(() => (index + 1) % images.length, [index]);
  const previousIndex = useMemo(() => (index + images.length - 1) % images.length, [index]);

  if (!isOpen) {
    return null;
  }

  const slides = useMemo(
    () =>
      images.map((image, slideIndex) => ({
        src: getImageSrc(image),
        title: getImageTitle(slideIndex),
      })),
    [images, getImageSrc, getImageTitle],
  );

  return (
    <LightboxBase
      open={isOpen}
      close={onClose}
      slides={slides}
      index={index}
      plugins={[Zoom]}
      on={{ view: ({ index: next }) => setIndex(next) }}
    />
  );
}
